import { api } from 'api/api';
const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

const useViewModalNotificacao = (props) => {
  const handleReadNotification = async (id, rota) => {
    try {
      if (rota) {
        await api(`${ENDPOINT}/cache/notificacoes-sns/${id}/read`, {
          method: 'PATCH',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
        });
      } else {
        await api(`${ENDPOINT}/cache/schedule-changes/${id}/read`, {
          method: 'PATCH',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
        });
      }

      if (typeof props.refetch === 'function') {
        props.refetch();
      }
    } catch (error) {
      console.log(error);
    }
  };
  return {
    handleReadNotification,
  };
};

export default useViewModalNotificacao;
